<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/sender/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Senders
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    Upload Senders
  </div>
  <div class="page-content shadow p-3 position-relative">
    <h4>New Sender CSV Upload</h4>
    <div class="row my-3">
      <div class="col-md-12">
        <div class="floating-label">
          <input type="file" class="floating-input" />
          <label for="csv-upload">CSV File</label>
        </div>
      </div>
      <div class="col-md-12">
        <button class="btn primary-btn w-100 mt-3">Upload File</button>
      </div>
    </div>
    <span class="text-danger"><b>Please Note</b></span>
    <p>
      The headings for each row should follow this format: tame, mname, Iname,
      gender, type, residency status, nationality, dob, place of birth, country
      of birth, status, comments, address1, address2, city, state, postcode,
      email, telephone, mobile, id1_type, id1_details, id1 issued by,
      Id1_issue_place, id1_start, id1_expiry, id2 type, id2 details, id2 issued
      by, id2 issue place, id2 start, id2_expiry, id3_type, id3_details, id3
      issued by, id3_issue_place, id3_start, id3 expiry, id4_type, id4_details,
      id4 issued by, id4_issue_place, id4_start, id4_expiry, account number,
      sort_code, groups, oigtype, company_name, company_type, company_reg_no,
      purpose, source_of_income, employer, business address, annual income,
      annual remittance, referral code, nearest airport
    </p>
    <p>
      If providing the group then please provide the group names separated by
      commas
    </p>
    <p class="text-primary">Download Template</p>
  </div>
</div>
